import Vue from 'vue'
import VueMarqueeSlider from 'vue-marquee-slider'
Vue.use(VueMarqueeSlider)
